export var ENGINE_URL = 'http://kitchen-app/kit'
if (process.env.NODE_ENV === 'production') ENGINE_URL = '/kit';